export default "__VITE_ASSET__DQrMncPV__"